import React from "react";
import "../Styling/PayrollTheme.css";

const AttendanceTiles = ({ summary, filters }) => {
  const isEmployee = !!filters.resourceId;

  return (
    <div className="pac-tiles__grid">
      {!isEmployee && (
        <div className="pac-tiles__card">
          <div className="pac-tiles__label">Total Employees</div>
          <div className="pac-tiles__value">{summary?.totalEmployees ?? 0}</div>
        </div>
      )}

      {isEmployee && (
        <>
          <div className="pac-tiles__card pac-tiles__card--present">
            <div className="pac-tiles__label">Present</div>
            <div className="pac-tiles__value">{summary?.present ?? 0}</div>
          </div>

          <div className="pac-tiles__card pac-tiles__card--absent">
            <div className="pac-tiles__label">Absent</div>
            <div className="pac-tiles__value">{summary?.absent ?? 0}</div>
          </div>

          <div className="pac-tiles__card pac-tiles__card--leave">
            <div className="pac-tiles__label">Leave</div>
            <div className="pac-tiles__value">{summary?.leave ?? 0}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default AttendanceTiles;
